import React, { useState, useEffect, useMemo } from 'react';
import { IoAddCircleOutline, IoClose, IoEye, IoEyeOff, IoSearch, IoChevronDown, IoAdd, IoRemove, IoPeople, IoPerson, IoBuild, IoBusiness } from 'react-icons/io5';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchUsers, createUser, fetchAreaHeads } from '../api/api';
import './Users.css';

const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
];

const DISTRICTS_BY_STATE = {
  'Andhra Pradesh': ['Anantapur', 'Chittoor', 'East Godavari', 'Guntur', 'Kadapa', 'Krishna', 'Kurnool', 'Nellore', 'Prakasam', 'Srikakulam', 'Visakhapatnam', 'Vizianagaram', 'West Godavari'],
  'Arunachal Pradesh': ['Anjaw', 'Changlang', 'East Kameng', 'East Siang', 'Kamle', 'Kra Daadi', 'Kurung Kumey', 'Lepa Rada', 'Lohit', 'Longding', 'Lower Dibang Valley', 'Lower Siang', 'Lower Subansiri', 'Namsai', 'Pakke Kessang', 'Papum Pare', 'Shi Yomi', 'Siang', 'Tawang', 'Tirap', 'Upper Dibang Valley', 'Upper Siang', 'Upper Subansiri', 'West Kameng', 'West Siang'],
  'Assam': ['Baksa', 'Barpeta', 'Biswanath', 'Bongaigaon', 'Cachar', 'Charaideo', 'Chirang', 'Darrang', 'Dhemaji', 'Dhubri', 'Dibrugarh', 'Goalpara', 'Golaghat', 'Hailakandi', 'Hojai', 'Jorhat', 'Kamrup', 'Kamrup Metropolitan', 'Karbi Anglong', 'Karimganj', 'Kokrajhar', 'Lakhimpur', 'Majuli', 'Morigaon', 'Nagaon', 'Nalbari', 'Sivasagar', 'Sonitpur', 'South Salmara-Mankachar', 'Tinsukia', 'Udalguri', 'West Karbi Anglong'],
  'Bihar': ['Araria', 'Arwal', 'Aurangabad', 'Banka', 'Begusarai', 'Bhagalpur', 'Bhojpur', 'Buxar', 'Darbhanga', 'East Champaran', 'Gaya', 'Gopalganj', 'Jamui', 'Jehanabad', 'Kaimur', 'Katihar', 'Khagaria', 'Kishanganj', 'Lakhisarai', 'Madhepura', 'Madhubani', 'Munger', 'Muzaffarpur', 'Nalanda', 'Nawada', 'Patna', 'Purnia', 'Rohtas', 'Saharsa', 'Samastipur', 'Saran', 'Sheikhpura', 'Sheohar', 'Sitamarhi', 'Siwan', 'Supaul', 'Vaishali', 'West Champaran'],
  'Chhattisgarh': ['Balod', 'Baloda Bazar', 'Balrampur', 'Bastar', 'Bemetara', 'Bijapur', 'Bilaspur', 'Dantewada', 'Dhamtari', 'Durg', 'Gariaband', 'Gaurela-Pendra-Marwahi', 'Janjgir-Champa', 'Jashpur', 'Kabirdham', 'Kanker', 'Kondagaon', 'Korba', 'Koriya', 'Mahasamund', 'Mungeli', 'Narayanpur', 'Raigarh', 'Raipur', 'Rajnandgaon', 'Sakti', 'Sarangarh-Bilaigarh', 'Sukma', 'Surajpur'],
  'Goa': ['North Goa', 'South Goa'],
  'Gujarat': ['Ahmedabad', 'Amreli', 'Anand', 'Aravalli', 'Banaskantha', 'Bharuch', 'Bhavnagar', 'Botad', 'Chhota Udaipur', 'Dahod', 'Dang', 'Devbhoomi Dwarka', 'Gandhinagar', 'Gir Somnath', 'Jamnagar', 'Junagadh', 'Kheda', 'Kutch', 'Mahisagar', 'Mehsana', 'Morbi', 'Narmada', 'Navsari', 'Panchmahal', 'Patan', 'Porbandar', 'Rajkot', 'Sabarkantha', 'Surat', 'Surendranagar', 'Tapi', 'Vadodara', 'Valsad'],
  'Haryana': ['Ambala', 'Bhiwani', 'Charkhi Dadri', 'Faridabad', 'Fatehabad', 'Gurugram', 'Hisar', 'Jhajjar', 'Jind', 'Kaithal', 'Karnal', 'Kurukshetra', 'Mahendragarh', 'Nuh', 'Palwal', 'Panchkula', 'Panipat', 'Rewari', 'Rohtak', 'Sirsa', 'Sonipat', 'Yamunanagar'],
  'Himachal Pradesh': ['Bilaspur', 'Chamba', 'Hamirpur', 'Kangra', 'Kinnaur', 'Kullu', 'Lahaul and Spiti', 'Mandi', 'Shimla', 'Sirmaur', 'Solan', 'Una'],
  'Jharkhand': ['Bokaro', 'Chatra', 'Deoghar', 'Dhanbad', 'Dumka', 'East Singhbhum', 'Garhwa', 'Giridih', 'Godda', 'Gumla', 'Hazaribagh', 'Jamtara', 'Khunti', 'Koderma', 'Latehar', 'Lohardaga', 'Pakur', 'Palamu', 'Ramgarh', 'Ranchi', 'Sahebganj', 'Seraikela Kharsawan', 'Simdega', 'West Singhbhum'],
  'Karnataka': ['Bagalkot', 'Bangalore Rural', 'Bangalore Urban', 'Belgaum', 'Bellary', 'Bidar', 'Chamarajanagar', 'Chikballapur', 'Chikkamagaluru', 'Chitradurga', 'Dakshina Kannada', 'Davanagere', 'Dharwad', 'Gadag', 'Gulbarga', 'Hassan', 'Haveri', 'Kodagu', 'Kolar', 'Koppal', 'Mandya', 'Mysore', 'Raichur', 'Ramanagara', 'Shimoga', 'Tumkur', 'Udupi', 'Uttara Kannada', 'Vijayapura', 'Yadgir'],
  'Kerala': ['Alappuzha', 'Ernakulam', 'Idukki', 'Kannur', 'Kasaragod', 'Kollam', 'Kottayam', 'Kozhikode', 'Malappuram', 'Palakkad', 'Pathanamthitta', 'Thiruvananthapuram', 'Thrissur', 'Wayanad'],
  'Madhya Pradesh': ['Agar Malwa', 'Alirajpur', 'Anuppur', 'Ashoknagar', 'Balaghat', 'Barwani', 'Betul', 'Bhind', 'Bhopal', 'Burhanpur', 'Chhatarpur', 'Chhindwara', 'Damoh', 'Datia', 'Dewas', 'Dhar', 'Dindori', 'Guna', 'Gwalior', 'Harda', 'Hoshangabad', 'Indore', 'Jabalpur', 'Jhabua', 'Katni', 'Khandwa', 'Khargone', 'Mandla', 'Mandsaur', 'Morena', 'Narsinghpur', 'Neemuch', 'Panna', 'Raisen', 'Rajgarh', 'Ratlam', 'Rewa', 'Sagar', 'Satna', 'Sehore', 'Seoni', 'Shahdol', 'Shajapur', 'Sheopur', 'Shivpuri', 'Sidhi', 'Singrauli', 'Tikamgarh', 'Ujjain', 'Umaria', 'Vidisha'],
  'Maharashtra': ['Ahmednagar', 'Akola', 'Amravati', 'Aurangabad', 'Beed', 'Bhandara', 'Buldhana', 'Chandrapur', 'Dhule', 'Gadchiroli', 'Gondia', 'Hingoli', 'Jalgaon', 'Jalna', 'Kolhapur', 'Latur', 'Mumbai City', 'Mumbai Suburban', 'Nagpur', 'Nanded', 'Nandurbar', 'Nashik', 'Osmanabad', 'Palghar', 'Parbhani', 'Pune', 'Raigad', 'Ratnagiri', 'Sangli', 'Satara', 'Sindhudurg', 'Solapur', 'Thane', 'Wardha', 'Washim', 'Yavatmal'],
  'Manipur': ['Bishnupur', 'Chandel', 'Churachandpur', 'Imphal East', 'Imphal West', 'Jiribam', 'Kakching', 'Kamjong', 'Kangpokpi', 'Noney', 'Pherzawl', 'Senapati', 'Tamenglong', 'Tengnoupal', 'Thoubal', 'Ukhrul'],
  'Meghalaya': ['East Garo Hills', 'East Jaintia Hills', 'East Khasi Hills', 'North Garo Hills', 'Ri Bhoi', 'South Garo Hills', 'South West Garo Hills', 'South West Khasi Hills', 'West Garo Hills', 'West Jaintia Hills', 'West Khasi Hills'],
  'Mizoram': ['Aizawl', 'Champhai', 'Hnahthial', 'Khawzawl', 'Kolasib', 'Lawngtlai', 'Lunglei', 'Mamit', 'Saiha', 'Saitual', 'Serchhip'],
  'Nagaland': ['Chumukedima', 'Dimapur', 'Kiphire', 'Kohima', 'Longleng', 'Mokokchung', 'Mon', 'Niuland', 'Noklak', 'Peren', 'Phek', 'Shamator', 'Tseminyu', 'Tuensang', 'Wokha', 'Zunheboto'],
  'Odisha': ['Angul', 'Balangir', 'Balasore', 'Bargarh', 'Bhadrak', 'Boudh', 'Cuttack', 'Deogarh', 'Dhenkanal', 'Gajapati', 'Ganjam', 'Jagatsinghpur', 'Jajpur', 'Jharsuguda', 'Kalahandi', 'Kandhamal', 'Kendrapara', 'Kendujhar', 'Khordha', 'Koraput', 'Malkangiri', 'Mayurbhanj', 'Nabarangpur', 'Nayagarh', 'Nuapada', 'Puri', 'Rayagada', 'Sambalpur', 'Subarnapur', 'Sundergarh'],
  'Punjab': ['Amritsar', 'Barnala', 'Bathinda', 'Faridkot', 'Fatehgarh Sahib', 'Fazilka', 'Ferozepur', 'Gurdaspur', 'Hoshiarpur', 'Jalandhar', 'Kapurthala', 'Ludhiana', 'Malerkotla', 'Mansa', 'Moga', 'Muktsar', 'Nawanshahr', 'Pathankot', 'Patiala', 'Rupnagar', 'Sangrur', 'SAS Nagar', 'Tarn Taran'],
  'Rajasthan': ['Ajmer', 'Alwar', 'Banswara', 'Baran', 'Barmer', 'Bharatpur', 'Bhilwara', 'Bikaner', 'Bundi', 'Chittorgarh', 'Churu', 'Dausa', 'Dholpur', 'Dungarpur', 'Hanumangarh', 'Jaipur', 'Jaisalmer', 'Jalore', 'Jhalawar', 'Jhunjhunu', 'Jodhpur', 'Karauli', 'Kota', 'Nagaur', 'Pali', 'Pratapgarh', 'Rajsamand', 'Sawai Madhopur', 'Sikar', 'Sirohi', 'Sri Ganganagar', 'Tonk', 'Udaipur'],
  'Sikkim': ['East Sikkim', 'North Sikkim', 'South Sikkim', 'West Sikkim'],
  'Tamil Nadu': ['Ariyalur', 'Chengalpattu', 'Chennai', 'Coimbatore', 'Cuddalore', 'Dharmapuri', 'Dindigul', 'Erode', 'Kallakurichi', 'Kancheepuram', 'Kanyakumari', 'Karur', 'Krishnagiri', 'Madurai', 'Mayiladuthurai', 'Nagapattinam', 'Namakkal', 'Nilgiris', 'Perambalur', 'Pudukkottai', 'Ramanathapuram', 'Ranipet', 'Salem', 'Sivaganga', 'Tenkasi', 'Thanjavur', 'Theni', 'Thoothukudi', 'Tiruchirappalli', 'Tirunelveli', 'Tirupathur', 'Tiruppur', 'Tiruvallur', 'Tiruvannamalai', 'Tiruvarur', 'Vellore', 'Viluppuram', 'Virudhunagar'],
  'Telangana': ['Adilabad', 'Bhadradri Kothagudem', 'Hyderabad', 'Jagtial', 'Jangaon', 'Jayashankar Bhupalpally', 'Jogulamba Gadwal', 'Kamareddy', 'Karimnagar', 'Khammam', 'Komaram Bheem', 'Mahabubabad', 'Mahabubnagar', 'Mancherial', 'Medak', 'Medchal-Malkajgiri', 'Mulugu', 'Nagarkurnool', 'Nalgonda', 'Narayanpet', 'Nirmal', 'Nizamabad', 'Peddapalli', 'Rajanna Sircilla', 'Rangareddy', 'Sangareddy', 'Siddipet', 'Suryapet', 'Vikarabad', 'Wanaparthy', 'Warangal Rural', 'Warangal Urban', 'Yadadri Bhuvanagiri'],
  'Tripura': ['Dhalai', 'Gomati', 'Khowai', 'North Tripura', 'Sepahijala', 'South Tripura', 'Unakoti', 'West Tripura'],
  'Uttar Pradesh': ['Agra', 'Aligarh', 'Ambedkar Nagar', 'Amethi', 'Amroha', 'Auraiya', 'Ayodhya', 'Azamgarh', 'Baghpat', 'Bahraich', 'Ballia', 'Balrampur', 'Banda', 'Barabanki', 'Bareilly', 'Basti', 'Bhadohi', 'Bijnor', 'Budaun', 'Bulandshahr', 'Chandauli', 'Chitrakoot', 'Deoria', 'Etah', 'Etawah', 'Farrukhabad', 'Fatehpur', 'Firozabad', 'Gautam Buddha Nagar', 'Ghaziabad', 'Ghazipur', 'Gonda', 'Gorakhpur', 'Hamirpur', 'Hapur', 'Hardoi', 'Hathras', 'Jalaun', 'Jaunpur', 'Jhansi', 'Kannauj', 'Kanpur Dehat', 'Kanpur Nagar', 'Kasganj', 'Kaushambi', 'Kheri', 'Kushinagar', 'Lalitpur', 'Lucknow', 'Maharajganj', 'Mahoba', 'Mainpuri', 'Mathura', 'Mau', 'Meerut', 'Mirzapur', 'Moradabad', 'Muzaffarnagar', 'Pilibhit', 'Pratapgarh', 'Prayagraj', 'Raebareli', 'Rampur', 'Saharanpur', 'Sambhal', 'Sant Kabir Nagar', 'Shahjahanpur', 'Shamli', 'Shrawasti', 'Siddharthnagar', 'Sitapur', 'Sonbhadra', 'Sultanpur', 'Unnao', 'Varanasi'],
  'Uttarakhand': ['Almora', 'Bageshwar', 'Chamoli', 'Champawat', 'Dehradun', 'Haridwar', 'Nainital', 'Pauri Garhwal', 'Pithoragarh', 'Rudraprayag', 'Tehri Garhwal', 'Udham Singh Nagar', 'Uttarkashi'],
  'West Bengal': ['Alipurduar', 'Bankura', 'Birbhum', 'Cooch Behar', 'Dakshin Dinajpur', 'Darjeeling', 'Hooghly', 'Howrah', 'Jalpaiguri', 'Jhargram', 'Kalimpong', 'Kolkata', 'Malda', 'Murshidabad', 'Nadia', 'North 24 Parganas', 'Paschim Bardhaman', 'Paschim Medinipur', 'Purba Bardhaman', 'Purba Medinipur', 'Purulia', 'South 24 Parganas', 'Uttar Dinajpur'],
  'Andaman and Nicobar Islands': ['Nicobar', 'North and Middle Andaman', 'South Andaman'],
  'Chandigarh': ['Chandigarh'],
  'Dadra and Nagar Haveli and Daman and Diu': ['Dadra and Nagar Haveli', 'Daman', 'Diu'],
  'Delhi': ['Central Delhi', 'East Delhi', 'New Delhi', 'North Delhi', 'North East Delhi', 'North West Delhi', 'Shahdara', 'South Delhi', 'South East Delhi', 'South West Delhi', 'West Delhi'],
  'Jammu and Kashmir': ['Anantnag', 'Bandipora', 'Baramulla', 'Budgam', 'Doda', 'Ganderbal', 'Jammu', 'Kathua', 'Kishtwar', 'Kulgam', 'Kupwara', 'Poonch', 'Pulwama', 'Rajouri', 'Ramban', 'Reasi', 'Samba', 'Shopian', 'Srinagar', 'Udhampur'],
  'Ladakh': ['Kargil', 'Leh'],
  'Lakshadweep': ['Lakshadweep'],
  'Puducherry': ['Karaikal', 'Mahe', 'Puducherry', 'Yanam']
};

const SYSTEM_TYPES = [
  'Hydraulic Stack', '3LD', '3LD 3POLE', '2 LD', '4LD', 'Cantilever',
  'Mechanical Stack', '3Pole Stack', 'Tower [0:1]', 'Tower [0:2]',
  'Tower [1:1]', 'Tower [2:1]', 'Tower [1:2]', 'Tower [2:2]',
  'Hydraulic Puzzle', 'Mechanical Puzzle'
];

const Users = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [selectedRole, setSelectedRole] = useState('user');
  const [selectedCompanyType, setSelectedCompanyType] = useState('AMC');
  const [showPassword, setShowPassword] = useState(false);
  const [areaHeads, setAreaHeads] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    userId: '',
    password: '',
    siteName: '',
    siteAddress: '',
    state: '',
    district: '',
    systemTypes: [],
    systemTypeQuantities: {},
    carCount: '',
    totalSystems: '',
    areaHeadId: '',
  });

  // Modal states
  const [showSystemTypesModal, setShowSystemTypesModal] = useState(false);
  const [customSystemType, setCustomSystemType] = useState('');
  const [customSystemTypeQty, setCustomSystemTypeQty] = useState(1);
  const [showAreaHeadModal, setShowAreaHeadModal] = useState(false);
  const [showStateModal, setShowStateModal] = useState(false);
  const [showDistrictModal, setShowDistrictModal] = useState(false);
  const [stateSearch, setStateSearch] = useState('');
  const [districtSearch, setDistrictSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');

  const loadUsers = async () => {
    try {
      const data = await fetchUsers();
      setUsers(Array.isArray(data) ? data : []);
    } catch {
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const loadAreaHeads = async () => {
    try {
      const data = await fetchAreaHeads();
      setAreaHeads(Array.isArray(data) ? data : []);
    } catch {
      setAreaHeads([]);
    }
  };

  useEffect(() => {
    loadUsers();
    loadAreaHeads();
  }, []);

  useEffect(() => {
    if (location.state?.openAddModal) {
      setShowModal(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.openAddModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const resetForm = () => {
    setFormData({
      name: '', email: '', phone: '', userId: '', password: '',
      siteName: '', siteAddress: '', state: '', district: '',
      systemTypes: [], systemTypeQuantities: {}, carCount: '',
      totalSystems: '', areaHeadId: ''
    });
    setSelectedRole('user');
    setSelectedCompanyType('AMC');
    setShowPassword(false);
    setError('');
    setStateSearch('');
    setDistrictSearch('');
    setCustomSystemType('');
    setCustomSystemTypeQty(1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!formData.name?.trim() || !formData.email?.trim() || !formData.userId?.trim() || !formData.password?.trim()) {
      setError('Please fill all required fields');
      return;
    }
    if (selectedRole === 'user' && (!formData.siteName?.trim() || !formData.siteAddress?.trim())) {
      setError('Site details are required for users');
      return;
    }
    if (selectedRole === 'area_head' && (!formData.state || !formData.district)) {
      setError('State and District are required for Area Heads');
      return;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setSubmitting(true);
    try {
      const newUser = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: formData.phone?.trim() || undefined,
        userId: formData.userId.trim(),
        password: formData.password,
        role: selectedRole,
        siteName: selectedRole === 'user' ? formData.siteName.trim() : undefined,
        siteAddress: selectedRole === 'user' ? formData.siteAddress.trim() : undefined,
        siteType: selectedRole === 'user' ? selectedCompanyType : undefined,
        state: selectedRole === 'area_head' ? formData.state : undefined,
        area: selectedRole === 'area_head' ? formData.district : undefined,
        systemTypes: selectedRole === 'user' && formData.systemTypes.length > 0 ? formData.systemTypes : undefined,
        systemTypeQuantities: selectedRole === 'user' && Object.keys(formData.systemTypeQuantities).length > 0 ? formData.systemTypeQuantities : undefined,
        carCount: selectedRole === 'user' && formData.carCount ? parseInt(formData.carCount) : undefined,
        totalSystems: selectedRole === 'user' && formData.totalSystems ? parseInt(formData.totalSystems) : undefined,
        areaHeadId: (selectedRole === 'user' || selectedRole === 'engineer') && formData.areaHeadId ? parseInt(formData.areaHeadId) : undefined,
      };
      await createUser(newUser);
      setShowModal(false);
      resetForm();
      await loadUsers();
    } catch (err) {
      setError(err.message || 'Failed to create user');
    } finally {
      setSubmitting(false);
    }
  };

  const toggleSystemType = (type) => {
    setFormData(prev => {
      const types = prev.systemTypes.includes(type)
        ? prev.systemTypes.filter(t => t !== type)
        : [...prev.systemTypes, type];
      const quantities = { ...prev.systemTypeQuantities };
      if (!prev.systemTypes.includes(type)) {
        quantities[type] = 1;
      } else {
        delete quantities[type];
      }
      return { ...prev, systemTypes: types, systemTypeQuantities: quantities };
    });
  };

  const updateSystemTypeQuantity = (type, delta) => {
    setFormData(prev => {
      const currentQty = prev.systemTypeQuantities[type] || 1;
      const newQty = Math.max(1, currentQty + delta);
      return {
        ...prev,
        systemTypeQuantities: { ...prev.systemTypeQuantities, [type]: newQty }
      };
    });
  };

  const addCustomSystemType = () => {
    if (!customSystemType.trim()) return;
    const typeName = customSystemType.trim();
    setFormData(prev => {
      if (prev.systemTypes.includes(typeName)) {
        return prev;
      }
      return {
        ...prev,
        systemTypes: [...prev.systemTypes, typeName],
        systemTypeQuantities: { ...prev.systemTypeQuantities, [typeName]: customSystemTypeQty }
      };
    });
    setCustomSystemType('');
    setCustomSystemTypeQty(1);
  };

  const handleRoleChange = (role) => {
    setSelectedRole(role);
    setFormData(prev => ({ ...prev, areaHeadId: '', state: '', district: '' }));
  };

  const filteredStates = stateSearch
    ? INDIAN_STATES.filter(s => s.toLowerCase().includes(stateSearch.toLowerCase()))
    : INDIAN_STATES;

  const availableDistricts = formData.state ? (DISTRICTS_BY_STATE[formData.state] || []) : [];
  const filteredDistricts = districtSearch
    ? availableDistricts.filter(d => d.toLowerCase().includes(districtSearch.toLowerCase()))
    : availableDistricts;

  const getRoleColor = (role) => {
    if (role === 'admin') return 'var(--admin, #FF9800)';
    if (role === 'engineer') return 'var(--success, #4CAF50)';
    if (role === 'area_head') return 'var(--info, #2196F3)';
    return 'var(--primary, #F57C00)';
  };

  const getRoleIcon = (role) => {
    if (role === 'admin') return <IoBusiness />;
    if (role === 'engineer') return <IoBuild />;
    if (role === 'area_head') return <IoPeople />;
    return <IoPerson />;
  };

  const getRoleLabel = (role) => {
    if (role === 'area_head') return 'Area Head';
    return (role || '').charAt(0).toUpperCase() + (role || '').slice(1);
  };

  // Filter and search users
  const filteredUsers = useMemo(() => {
    return users.filter(user => {
      const matchesSearch = !searchQuery || 
        user.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.userId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.user_id?.toLowerCase().includes(searchQuery.toLowerCase());
      
      const matchesRole = roleFilter === 'all' || user.role?.toLowerCase() === roleFilter.toLowerCase();
      
      return matchesSearch && matchesRole;
    });
  }, [users, searchQuery, roleFilter]);

  // Stats
  const stats = useMemo(() => ({
    total: users.length,
    active: users.filter(u => u.is_active !== false).length,
    inactive: users.filter(u => u.is_active === false).length,
    byRole: {
      user: users.filter(u => u.role === 'user').length,
      engineer: users.filter(u => u.role === 'engineer').length,
      area_head: users.filter(u => u.role === 'area_head').length,
      admin: users.filter(u => u.role === 'admin').length,
    }
  }), [users]);

  return (
    <div className="users-screen">
      {/* Header */}
      <div className="users-header">
        <div className="users-header-title">
          <h1 className="users-title">Users</h1>
          <span className="users-subtitle">{stats.total} total users</span>
        </div>
        <button className="users-add-btn" onClick={() => setShowModal(true)}>
          <IoAddCircleOutline className="add-icon" />
          <span>Add User</span>
        </button>
      </div>

      {/* Stats Cards */}
      <div className="users-stats">
        <div className="stat-card">
          <div className="stat-icon total"><IoPeople /></div>
          <div className="stat-info">
            <span className="stat-value">{stats.total}</span>
            <span className="stat-label">Total Users</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon active"><IoPerson /></div>
          <div className="stat-info">
            <span className="stat-value">{stats.active}</span>
            <span className="stat-label">Active</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon inactive"><IoPerson /></div>
          <div className="stat-info">
            <span className="stat-value">{stats.inactive}</span>
            <span className="stat-label">Inactive</span>
          </div>
        </div>
      </div>

      {/* Search and Filter */}
      <div className="users-filter-bar">
        <div className="search-box">
          <IoSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search by name, email, or user ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button className="clear-search" onClick={() => setSearchQuery('')}>
              <IoClose />
            </button>
          )}
        </div>
        <div className="role-filter">
          {['all', 'user', 'engineer', 'area_head'].map(role => (
            <button
              key={role}
              className={`filter-btn ${roleFilter === role ? 'active' : ''}`}
              onClick={() => setRoleFilter(role)}
            >
              {role === 'all' ? 'All' : getRoleLabel(role) + 's'}
              {role !== 'all' && stats.byRole[role] > 0 && (
                <span className="filter-count">{stats.byRole[role]}</span>
              )}
            </button>
          ))}
        </div>
      </div>

      {showModal && (
        <div className="users-modal-overlay" onClick={() => !submitting && (resetForm(), setShowModal(false))} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Escape' && !submitting && (resetForm(), setShowModal(false))}>
          <div className="users-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="add-user-title">
            <div className="users-modal-header">
              <h2 id="add-user-title">Add User</h2>
              <button type="button" className="users-modal-close" onClick={() => !submitting && (resetForm(), setShowModal(false))} aria-label="Close">
                <IoClose />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="users-modal-form">
              {error && <div className="users-modal-error">{error}</div>}

              <div className="users-form-group">
                <label>User Type</label>
                <div className="users-role-buttons">
                  {['user', 'engineer', 'area_head'].map((role) => (
                    <button
                      key={role}
                      type="button"
                      className={`users-role-btn ${selectedRole === role ? 'active' : ''}`}
                      onClick={() => handleRoleChange(role)}
                    >
                      {role === 'area_head' ? 'Area Head' : role.charAt(0).toUpperCase() + role.slice(1)}
                    </button>
                  ))}
                </div>
              </div>

              {(selectedRole === 'user' || selectedRole === 'engineer') && (
                <div className="users-form-group">
                  <label>Site Type</label>
                  <div className="users-role-buttons">
                    {['AMC', 'NON-AMC'].map((type) => (
                      <button
                        key={type}
                        type="button"
                        className={`users-role-btn ${selectedCompanyType === type ? 'active' : ''}`}
                        onClick={() => setSelectedCompanyType(type)}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {selectedRole === 'area_head' && (
                <>
                  <div className="users-form-group">
                    <label>State *</label>
                    <button
                      type="button"
                      className="users-dropdown-trigger"
                      onClick={() => setShowStateModal(true)}
                    >
                      <span>{formData.state || 'Select State'}</span>
                      <IoChevronDown />
                    </button>
                  </div>
                  <div className="users-form-group">
                    <label>District *</label>
                    <button
                      type="button"
                      className="users-dropdown-trigger"
                      onClick={() => formData.state && setShowDistrictModal(true)}
                      disabled={!formData.state}
                    >
                      <span>{formData.district || 'Select District'}</span>
                      <IoChevronDown />
                    </button>
                  </div>
                </>
              )}

              <div className="users-form-group">
                <label htmlFor="name">Full Name *</label>
                <input id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter full name" required />
              </div>
              <div className="users-form-group">
                <label htmlFor="email">Email *</label>
                <input id="email" type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter email" required />
              </div>
              <div className="users-form-group">
                <label htmlFor="phone">Phone Number</label>
                <input id="phone" type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter phone number" />
              </div>
              <div className="users-form-group">
                <label htmlFor="userId">User ID *</label>
                <input id="userId" name="userId" value={formData.userId} onChange={handleChange} placeholder="Enter unique user ID" required />
              </div>
              <div className="users-form-group">
                <label htmlFor="password">Password *</label>
                <div className="users-password-input">
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter password (min 6 characters)"
                    required
                    minLength={6}
                  />
                  <button
                    type="button"
                    className="users-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <IoEyeOff /> : <IoEye />}
                  </button>
                </div>
              </div>

              {(selectedRole === 'user' || selectedRole === 'engineer') && (
                <div className="users-form-group">
                  <label>Assign Area Head</label>
                  <button
                    type="button"
                    className="users-dropdown-trigger"
                    onClick={() => setShowAreaHeadModal(true)}
                  >
                    <span>
                      {formData.areaHeadId
                        ? areaHeads.find(ah => ah.id === parseInt(formData.areaHeadId))?.name || 'Select Area Head'
                        : 'Select Area Head'}
                    </span>
                    <IoChevronDown />
                  </button>
                </div>
              )}

              {selectedRole === 'user' && (
                <>
                  <div className="users-form-group">
                    <label htmlFor="siteName">Site Name *</label>
                    <input id="siteName" name="siteName" value={formData.siteName} onChange={handleChange} placeholder="Enter site name" />
                  </div>
                  <div className="users-form-group">
                    <label htmlFor="siteAddress">Site Address *</label>
                    <textarea id="siteAddress" name="siteAddress" value={formData.siteAddress} onChange={handleChange} placeholder="Enter site address" rows={3} />
                  </div>
                  <div className="users-form-group">
                    <label>System Types</label>
                    <button
                      type="button"
                      className="users-dropdown-trigger"
                      onClick={() => setShowSystemTypesModal(true)}
                    >
                      <span>
                        {formData.systemTypes.length > 0
                          ? `${formData.systemTypes.length} type(s) selected`
                          : 'Select System Types'}
                      </span>
                      <IoChevronDown />
                    </button>
                    {formData.systemTypes.length > 0 && (
                      <div className="users-selected-types">
                        {formData.systemTypes.map(type => (
                          <span key={type} className="users-type-tag">
                            {type} (x{formData.systemTypeQuantities[type] || 1})
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="users-form-row">
                    <div className="users-form-group half">
                      <label htmlFor="carCount">Car Count</label>
                      <input
                        id="carCount"
                        type="number"
                        name="carCount"
                        value={formData.carCount}
                        onChange={handleChange}
                        placeholder="Enter car count"
                        min="0"
                      />
                    </div>
                    <div className="users-form-group half">
                      <label htmlFor="totalSystems">Total No of Systems</label>
                      <input
                        id="totalSystems"
                        type="number"
                        name="totalSystems"
                        value={formData.totalSystems}
                        onChange={handleChange}
                        placeholder="Enter total systems"
                        min="0"
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="users-modal-actions">
                <button type="button" className="users-modal-cancel" onClick={() => !submitting && (resetForm(), setShowModal(false))} disabled={submitting}>Cancel</button>
                <button type="submit" className="users-modal-submit" disabled={submitting}>
                  {submitting ? 'Creating...' : `Create ${selectedRole === 'area_head' ? 'Area Head' : selectedRole.charAt(0).toUpperCase() + selectedRole.slice(1)}`}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* System Types Modal */}
      {showSystemTypesModal && (
        <div className="users-modal-overlay" onClick={() => setShowSystemTypesModal(false)}>
          <div className="users-modal users-selection-modal" onClick={(e) => e.stopPropagation()}>
            <div className="users-modal-header">
              <h2>Select System Types</h2>
              <button type="button" className="users-modal-close" onClick={() => setShowSystemTypesModal(false)}>
                <IoClose />
              </button>
            </div>
            <div className="users-selection-content">
              {/* Custom System Type Input */}
              <div className="users-custom-system-type">
                <div className="users-custom-input-row">
                  <input
                    type="text"
                    placeholder="Enter system name"
                    value={customSystemType}
                    onChange={(e) => setCustomSystemType(e.target.value)}
                    className="users-custom-system-input"
                    onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addCustomSystemType())}
                  />
                  <input
                    type="number"
                    min="1"
                    value={customSystemTypeQty}
                    onChange={(e) => setCustomSystemTypeQty(Math.max(1, parseInt(e.target.value) || 1))}
                    className="users-custom-system-qty"
                  />
                  <button type="button" className="users-add-custom-btn" onClick={addCustomSystemType}>
                    <IoAdd />
                  </button>
                </div>
              </div>
              {SYSTEM_TYPES.map(type => (
                <div key={type} className="users-selection-item">
                  <label className="users-checkbox-label">
                    <input
                      type="checkbox"
                      checked={formData.systemTypes.includes(type)}
                      onChange={() => toggleSystemType(type)}
                    />
                    <span className="users-checkbox-custom"></span>
                    <span className="users-selection-text">{type}</span>
                  </label>
                  {formData.systemTypes.includes(type) && (
                    <div className="users-quantity-control">
                      <button type="button" onClick={() => updateSystemTypeQuantity(type, -1)}><IoRemove /></button>
                      <span>{formData.systemTypeQuantities[type] || 1}</span>
                      <button type="button" onClick={() => updateSystemTypeQuantity(type, 1)}><IoAdd /></button>
                    </div>
                  )}
                </div>
              ))}
              {/* Display custom system types */}
              {formData.systemTypes.filter(t => !SYSTEM_TYPES.includes(t)).map(type => (
                <div key={type} className="users-selection-item users-custom-type">
                  <label className="users-checkbox-label">
                    <input
                      type="checkbox"
                      checked={true}
                      onChange={() => toggleSystemType(type)}
                    />
                    <span className="users-checkbox-custom"></span>
                    <span className="users-selection-text">{type}</span>
                  </label>
                  <div className="users-quantity-control">
                    <button type="button" onClick={() => updateSystemTypeQuantity(type, -1)}><IoRemove /></button>
                    <span>{formData.systemTypeQuantities[type] || 1}</span>
                    <button type="button" onClick={() => updateSystemTypeQuantity(type, 1)}><IoAdd /></button>
                  </div>
                </div>
              ))}
            </div>
            <div className="users-modal-actions">
              <button type="button" className="users-modal-submit" onClick={() => setShowSystemTypesModal(false)}>Done</button>
            </div>
          </div>
        </div>
      )}

      {/* Area Head Selection Modal */}
      {showAreaHeadModal && (
        <div className="users-modal-overlay" onClick={() => setShowAreaHeadModal(false)}>
          <div className="users-modal users-selection-modal" onClick={(e) => e.stopPropagation()}>
            <div className="users-modal-header">
              <h2>Select Area Head</h2>
              <button type="button" className="users-modal-close" onClick={() => setShowAreaHeadModal(false)}>
                <IoClose />
              </button>
            </div>
            <div className="users-selection-content">
              {areaHeads.length === 0 ? (
                <p className="users-empty-message">No area heads available</p>
              ) : (
                areaHeads.map(ah => (
                  <button
                    key={ah.id}
                    type="button"
                    className={`users-selection-item-btn ${formData.areaHeadId === String(ah.id) ? 'active' : ''}`}
                    onClick={() => {
                      setFormData(prev => ({ ...prev, areaHeadId: String(ah.id) }));
                      setShowAreaHeadModal(false);
                    }}
                  >
                    <div className="users-selection-info">
                      <span className="users-selection-name">{ah.name}</span>
                      <span className="users-selection-detail">{ah.state}{ah.area ? `, ${ah.area}` : ''}</span>
                    </div>
                    {formData.areaHeadId === String(ah.id) && <span className="users-checkmark">✓</span>}
                  </button>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* State Selection Modal */}
      {showStateModal && (
        <div className="users-modal-overlay" onClick={() => setShowStateModal(false)}>
          <div className="users-modal users-selection-modal" onClick={(e) => e.stopPropagation()}>
            <div className="users-modal-header">
              <h2>Select State</h2>
              <button type="button" className="users-modal-close" onClick={() => setShowStateModal(false)}>
                <IoClose />
              </button>
            </div>
            <div className="users-search-box">
              <IoSearch className="users-search-icon" />
              <input
                type="text"
                placeholder="Search states..."
                value={stateSearch}
                onChange={(e) => setStateSearch(e.target.value)}
              />
            </div>
            <div className="users-selection-content">
              {filteredStates.map(state => (
                <button
                  key={state}
                  type="button"
                  className={`users-selection-item-btn ${formData.state === state ? 'active' : ''}`}
                  onClick={() => {
                    setFormData(prev => ({ ...prev, state, district: '' }));
                    setShowStateModal(false);
                    setStateSearch('');
                  }}
                >
                  <span>{state}</span>
                  {formData.state === state && <span className="users-checkmark">✓</span>}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* District Selection Modal */}
      {showDistrictModal && (
        <div className="users-modal-overlay" onClick={() => setShowDistrictModal(false)}>
          <div className="users-modal users-selection-modal" onClick={(e) => e.stopPropagation()}>
            <div className="users-modal-header">
              <h2>Select District - {formData.state}</h2>
              <button type="button" className="users-modal-close" onClick={() => setShowDistrictModal(false)}>
                <IoClose />
              </button>
            </div>
            <div className="users-search-box">
              <IoSearch className="users-search-icon" />
              <input
                type="text"
                placeholder="Search districts..."
                value={districtSearch}
                onChange={(e) => setDistrictSearch(e.target.value)}
              />
            </div>
            <div className="users-selection-content">
              {filteredDistricts.map(district => (
                <button
                  key={district}
                  type="button"
                  className={`users-selection-item-btn ${formData.district === district ? 'active' : ''}`}
                  onClick={() => {
                    setFormData(prev => ({ ...prev, district }));
                    setShowDistrictModal(false);
                    setDistrictSearch('');
                  }}
                >
                  <span>{district}</span>
                  {formData.district === district && <span className="users-checkmark">✓</span>}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <div className="users-loading">
          <div className="loading-spinner"></div>
          <p>Loading users...</p>
        </div>
      ) : filteredUsers.length === 0 ? (
        <div className="users-empty">
          <div className="empty-icon"><IoPeople /></div>
          <h3>No users found</h3>
          <p>{searchQuery ? 'Try adjusting your search' : 'No users in the system yet'}</p>
        </div>
      ) : (
        <div className="users-list">
          {filteredUsers.map((u) => (
            <div
              key={u.id || u.userId || u.user_id || u.email}
              className={`user-card ${(u.is_active === false) ? 'user-card-inactive' : ''}`}
              onClick={() => navigate(`/admin/users/${u.id}`)}
              onKeyDown={(e) => e.key === 'Enter' && navigate(`/admin/users/${u.id}`)}
              role="button"
              tabIndex={0}
            >
              <div className="user-card-left" style={{ background: getRoleColor(u.role) }}>
                {getRoleIcon(u.role)}
              </div>
              <div className="user-card-content">
                <div className="user-card-header-row">
                  <h3 className="user-name">{u.name}</h3>
                  <span
                    className="user-role-badge"
                    style={{ background: getRoleColor(u.role) }}
                  >
                    {getRoleLabel(u.role)}
                  </span>
                </div>
                <div className="user-meta">
                  <span className="user-id">{u.userId || u.user_id || u.id}</span>
                  <span className="dot-separator">•</span>
                  <span className="user-email">{u.email}</span>
                </div>
                {(u.site_name || u.siteName) && (
                  <div className="user-site-info">
                    <span>{u.site_name || u.siteName}</span>
                    {(u.site_type || u.siteType) && (
                      <span className={`site-type-badge ${(u.site_type || u.siteType).toLowerCase()}`}>
                        {u.site_type || u.siteType}
                      </span>
                    )}
                  </div>
                )}
              </div>
              <div className="user-card-arrow">›</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Users;
